import React, { useEffect } from "react";

/* -------- packages -------- */
import { useDispatch, useSelector } from "react-redux";
import { Container } from "reactstrap";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
/* -------- ------- -------- */

/* -------- intern functions -------- */
import { clearGroupErrors, fetchGroupRequest, updateGroupRequest } from "../../store/actions";
/* -------- ------- -------- */

/* -------- components -------- */
import Breadcrumb from "../../components/ui/Breadcrumbs";
import DynamicRightsForm from "../../components/ui/Form/DynamicRightsForm";
import menuItems from "../../utils/menuItems";
import ErrorHandler from "../../components/ui/Error/ErrorHandler";
/* -------- ------- -------- */

const GroupNewEditPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { id } = useParams(); // Get the id from the URL
  const parameters = useSelector(state => state.Parameters);
  const { group, loading, errorGroup } = useSelector(state => state.Groups);

  document.title = `${t('groups')} | ${parameters.appName}`; //meta title

  const keys = menuItems;

  useEffect(() => {
    if(id && !isNaN(id)){
      dispatch(fetchGroupRequest(id));
    }
  }, [dispatch, id]);

  ErrorHandler(errorGroup, clearGroupErrors);

  useEffect(() => {
    const preloader = document.getElementById("preloader");
    const status = document.getElementById("status");

    if (loading) {
      if (preloader) preloader.style.display = "block";
      if (status) status.style.display = "block";
    } else {
      if (preloader) preloader.style.display = "none";
      if (status) status.style.display = "none";
    }
  }, [loading]);

  const handleFormSubmit = (values) => {
    if(id && !isNaN(id)){
      dispatch(updateGroupRequest({ ...values, id }, navigate));
    } else {
      dispatch(updateGroupRequest(values, navigate));
    }
  };

  return (
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title={t("groups")} breadcrumbItem={t("groups")} />
          <DynamicRightsForm 
            keys={keys} 
            initialValues={id ? (group || {}) : {}} 
            onSubmit={handleFormSubmit} 
            error={errorGroup} // Pass the error to DynamicForm
            prefListName={'group'}
          />
        </Container>
        <ToastContainer />
      </div>
  );
};

export default GroupNewEditPage;
